<template>
  <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path stroke="currentColor" d="M1.25,17h3.5A.249.249,0,0,0,5,16.75v-2a1,1,0,0,0-1-1H2a1,1,0,0,0-1,1v2A.249.249,0,0,0,1.25,17Z" />
    <path stroke="currentColor" d="M8,8.75a1,1,0,0,0-1,1v7a.249.249,0,0,0,.25.25h3.5a.249.249,0,0,0,.25-.25v-7a1,1,0,0,0-1-1Z" />
    <path stroke="currentColor" d="M14,10.75a1,1,0,0,0-1,1v5a.249.249,0,0,0,.25.25h3.5a.249.249,0,0,0,.25-.25v-5a1,1,0,0,0-1-1Z" />
    <path stroke="currentColor" d="M19.25,17h3.5a.249.249,0,0,0,.25-.25v-12a1,1,0,0,0-1-1H20a1,1,0,0,0-1,1v12A.249.249,0,0,0,19.25,17Z" />
    <path stroke="currentColor" d="M1,20.25H23a1,1,0,0,0,0-2H1a1,1,0,0,0,0,2Z" />
  </svg>
</template>
